import "./styles.css";
import React, {useEffect, useState} from "react";
import {timePicker} from "analogue-time-picker";
import {Typography} from "@material-tailwind/react";

export function TimeClock({
                            label,
                            value,
                            onChange,
                          }) {
  const [ShowTime, setShowTime] = useState();
  const [Minute, setMinute] = useState();
  const [Hour, setHour] = useState();

  useEffect(() => {

    var time_picker = timePicker({
      element: document.getElementById("clock"),
      mode: 24,
      width: "200px",
      time: {
        hour: value.split(':').map(Number)[0] ? value.split(':').map(Number)[0] : 1,
        minute: value.split(':').map(Number)[1] ? value.split(':').map(Number)[1] : 0
      },
    })

    time_picker.onTimeChanged((hour, minute) => {
      if (hour && hour > 0) {
        setHour(hour);
      } else {
        setHour(0)
      }
      if (minute && minute > 0) {
        let new_minute = Math.ceil(minute / 5) * 5;
        if (new_minute > 59) {
          new_minute = 0;
        }
        setMinute(new_minute);
      } else {
        setMinute(0)
      }
    })

    setShowTime(time_picker);

    if (value) {
      if (value.length > 0) {
        const [Hours, Minutes] = value.split(':').map(Number);
        setHour(Hours);
        setMinute(Minutes);
        time_picker.setTime(Hours, Minutes);
      }
    }
  }, []);

  useEffect(() => {
    if (Hour !== undefined && Minute !== undefined) {
      const formattedTime = Hour.toString().padStart(2, '0') + ":" + Minute.toString().padStart(2, '0');
      onChange(formattedTime)
      ShowTime.setTime(Hour, Minute);
    }

  }, [Minute, Hour]);

  const formattedValue = `${(Hour ?? 0).toString().padStart(2, '0')}:${(Minute ?? 0).toString().padStart(2, '0')}`;

  return (
    <div className="time-clock-control flex w-full flex-col items-center" key={"value"}>
      <div className="mb-4 flex w-full items-center justify-between gap-3">
        <Typography className="text-sm font-medium text-gray-700">
          {label}
        </Typography>
        <Typography className="rounded-md bg-gray-100 px-3 py-1 text-sm font-bold text-gray-900">
          {formattedValue}
        </Typography>
      </div>
      <div className="TimeClock flex w-full justify-center">
        <div id="clock"></div>
      </div>
      {/*<Button className="mt-2" onClick={() => {*/}
      {/*  const object = ShowTime.getTime();*/}
      {/*  const new_minute = Math.ceil((object.minute / 5)) * 5*/}
      {/*  ShowTime.setTime(object.hour, new_minute);*/}
      {/*  const new_object = ShowTime.getTime();*/}
      {/*  setMinute(new_object.minute);*/}
      {/*  setHour(object.hour);*/}
      {/*}} color="#414141">*/}
      {/*  زمان شروع را ثبت کنید*/}
      {/*</Button>*/}
    </div>
  )
    ;
}
